import { GRAYSCALE_200 } from '../../styles/colors'
import styled from 'styled-components'

export const QRButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${GRAYSCALE_200};
    border-radius: 100%;
    cursor: pointer;
    aspect-ratio: 1/1;
    max-width: 48px;
    max-height: 48px;
    padding: 10px;
`
